import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import LogoColor from '../../../images/GreenAmerica-logo-Color.png';
import LogoWhite from '../../../images/GreenAmerica-logo-White.png';

const LogoStyled = styled.img`
    width: ${(props) => props.width};
    height: ${(props) => props.height};
`;

export default function Logo({
    className,
    height,
    isLogoWhite,
    width,
    logoGreenAmerica,
    whiteLogoGreeanAmerica,
}) {
    return (
        <Link to="/">
            {!isLogoWhite ? (
                <LogoStyled
                    className={className}
                    src={logoGreenAmerica?.url}
                    width={width}
                    height={height}
                    alt={logoGreenAmerica?.description}
                    title={logoGreenAmerica?.title}
                />
            ) : (
                <LogoStyled
                    className={className}
                    src={whiteLogoGreeanAmerica?.url}
                    width={width}
                    height={height}
                    alt={whiteLogoGreeanAmerica?.description}
                    title={whiteLogoGreeanAmerica?.title}
                />
            )}
        </Link>
    );
}

Logo.propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    isLogoWhite: PropTypes.bool,
    width: PropTypes.string,
};

Logo.defaultProps = {
    className: '',
    height: '77',
    isLogoWhite: false,
    width: '251',
};
